import React, { useState } from 'react';
import { Button, Grid } from '@mui/material';
import CommonDialog from 'components/commonDialog/CommonDialog';
import CommonFilter from 'components/commonFilter/CommonFilter';
import SearchBar from 'components/commonSearch/SearchBar';

function DriverBreadCrumb(props) {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const addVendor = () => {
    setOpen(true)
  }

  const onDialog = (data, code) => {
    props?.onSubmittBtn(data, code)
    setOpen(false);
  };

  return (
    <div>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className="margin10"
      >

        <Grid
          item
          container
          xs={6}
          md={12}
          rowspacing={4}
          direction="row"
          justifyContent="end"
          alignItems="center"
        >
          <Grid item className='marginRight10'>
            <SearchBar  onSearch={props.onSearch}/>
          </Grid>
          <Grid item className="marginLeft40">
            <CommonFilter
              defaultStatus={props?.defaultStatus} 
              filterdata={props?.filterdata} 
              onFilterChange={props?.onFilterChange}
              onRestFilter={props?.onRestFilter}
            />
          </Grid>
          {props?.companyType !=='adminCompany' && <Grid item>
            <Button onClick={() => addVendor()} className="btnSubvendor marginLeft40">
              Driver +
            </Button>
          </Grid>}
        </Grid>
      </Grid>
      {open && 
      <CommonDialog
        open={open} 
        handleClose={handleClose} 
        formData={props?.formData}
        button={'dialogButton'}
        onSubmittBtn={onDialog}
        type={'Driver'}
        selectType={'Create'}
        defaultValues={props?.defaultValues}
      />}
    </div>
  );
}

export default DriverBreadCrumb;
